<template>
    <div>
        <p v-if="showTitle" class="f-s-5 f-w-bold m-t-5 text-center">{{ trans('Give imported members access to products') }}</p>
        <div v-for="(product, index) in selectedProducts" v-bind:key="product.id" class="card br row m-b-6">
            <div class="column">
                <div class="card-content row row-collapse-indent row-middle m-t-4 m-b-4">
                    <div class="slat-figure--large column small-12">
                        <img v-bind:src="product.image ? product.image_url.thumbnail : product.placeholder_image_url" v-bind:alt="product.title" />
                    </div>
                    <div class="slat-content column p-l-0">
                        <div class="card-type f-s-2 c-muted f-w-bold m-b-2">{{ productFeatures(product) }}</div>
                        <h4 class="card-title c-primary f-s-4 m-b-0">{{ product.title }}</h4>
                    </div>
                    <div class="slat-aside text-right m-r-4">
                        <a v-on:click.prevent="deleteItem(index)" class="i-container i-filled-dark btn btn-text width-auto-min p-0 m-r-0" href="#remove-product">
                            <!-- /icons/remove.svg -->
                            <svg class="icon i-size-medium" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#FFF" cx="16" cy="16" r="16"/><path fill="#AAB2BD" fill-rule="nonzero" d="M23 10.41L21.59 9 16 14.59 10.41 9 9 10.41 14.59 16 9 21.59 10.41 23 16 17.41 21.59 23 23 21.59 17.41 16z"/></g></svg>
                        </a>
                    </div>
                </div>
            </div>
            <input type="hidden" v-bind:name="'products[' + index + ']'" v-model="product.id">
            <div class="columns p-b-1">
                <div class="br-top p-t-1"></div>
                <div class="row row-collapse row-middle">
                    <div v-if="product.type !== 'download'" class="column large-5">
                        <div class="control-group text-left p-b-micro p-t-micro">
                            <div class="form-group-addon inline">
                                <label class="control control-checkbox block c-muted m-b-0">
                                    {{ trans('Skip original drip schedule') }}
                                    <input type="checkbox" v-bind:name="'skip_drip_schedule[' + product.id + ']'" value="1">
                                    <div class="control-indicator control-checkbox-indicator"></div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <div class="c-muted f-s-2 p-r-4 text-right">{{ trans('Set Product Expiry') }}</div>
                    </div>
                    <div class="column">
                        <div class="form-group m-b-0">
                            <date-pick
                                v-model="product.ends_at"
                                v-bind:input-attributes="{'class': 'input__field input__field--date', 'placeholder': trans('Pick a date'), 'name': 'ends_at[' + product.id + ']'}"
                                v-bind:nextMonthCaption="datePickLabels.nextMonthCaption"
                                v-bind:prevMonthCaption="datePickLabels.prevMonthCaption"
                                v-bind:setTimeCaption="datePickLabels.setTimeCaption"
                                v-bind:weekdays="datePickLabels.weekdays"
                                v-bind:months="datePickLabels.months"
                            ></date-pick>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedProducts.length > 0" class="m-t-4 m-b-6">
            <div class="control-group text-center p-b-micro p-t-micro">
                <div class="form-group-addon inline">
                    <label class="control control-checkbox block c-muted m-b-0">
                        {{ trans('Send notification email') }}
                        <input type="checkbox" name="send_notification" value="1" v-model="shouldSendNotification">
                        <div class="control-indicator control-checkbox-indicator"></div>
                    </label>
                </div>
            </div>
        </div>
        <div class="text-center">
            <button v-on:click="addProduct" type="button" class="btn btn-text btn-text--accent btn-icon m-b-4">
                <span class="icon i-container i-filled-accent">
                    <!-- /icons/add.svg -->
                    <svg class="icon i-size-small inline" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M11 5v14h2V5z"/><path d="M19 11H5v2h14z"/></g></svg>
                </span>
                {{ trans('Add Product') }}
            </button>
        </div>
        <div v-if="errors.length > 0" class="form-help c-error">
            {{ errors }}
        </div>

        <product-picker-modal
            v-bind:products="filteredProducts"
            v-on:close="modal.show = false"
            v-on:select-product="selectProduct"
            ref="product-picker-modal"
        ></product-picker-modal>
    </div>
</template>
<script>
import DatePick from 'vue-date-pick';
import DatePickLocalizationMixin from '../fields/DatePickLocalizationMixin.vue';
import ProductPickerModal from '../memberships/ProductPickerModal.vue';
import { EventBus } from '../../event-bus';

export default {
    components: {
        DatePick,
        ProductPickerModal,
    },
    mixins: [
        DatePickLocalizationMixin
    ],
    props: {
        products: {
            type: Array,
        },
        selected: {
            type: Array,
        },
        errors: {
            type: String,
            default: '',
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        sendNotification: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            selectedProducts: [],
            selectedProductIds: _.get(this, 'selected', []),
            modal: null,
            shouldSendNotification: this.sendNotification,
        }
    },
    computed: {
        filteredProducts() {
            return this.products.filter((product) => {
                return _.indexOf(this.selectedProductIds, product.id) < 0 && _.indexOf(this.selectedProductIds, product.id + '') < 0;
            });
        },
    },
    methods: {
        addProduct() {
            this.modal.show = true;
        },
        selectProduct(product) {
            this.modal.show = false;
            this.selectedProducts.push(product);
            this.selectedProductIds.push(product.id);
            EventBus.$emit('form:element:changed', 'products', this.selectedProductIds.join('-'));
        },
        deleteItem(index) {
            this.selectedProducts.splice(index, 1);
            this.selectedProductIds.splice(index, 1);
            EventBus.$emit('form:element:changed', 'products', this.selectedProductIds.join('-'));
        },
        productFeatures(product) {
            if (typeof product.enabled_product_features == 'undefined') {
                return '';
            }

            return product.enabled_product_features[0].label;
        },
    },
    mounted() {
        this.modal = this.$refs['product-picker-modal'];

        this.$nextTick(() => {
            EventBus.$emit('form:element:initialize', 'products', this.selectedProductIds.join('-'));
        });
    },
    created() {
        if (this.selectedProductIds.length && this.products.length) {
            this.selectedProducts = this.selectedProductIds.map(id => _.find(this.products, {'id': id}) || _.find(this.products, {'id': parseInt(id)}));
        }
    }
}
</script>